import React from 'react';
import './cardWrapper.scss';

const ImageCard = (props) => {
  const { url, title, subTitle1, subTitle2, count } = props;
  return (
    <div>
      <article style={{ width: 100 }}>
        <figure className='analytic-image-container'>
          <img className='analytic-image' src={url} width={100} height={100} alt='' />
        </figure>
        <div className='analytic-top-five-bottom-right'>#{count}</div>
      </article>
      <div className='analytic-image-text-wrapper'>
        <div className='analytic-image-title'>{title}</div>
        <div className='analytic-image-sub'>{subTitle1}</div>
        <div className='analytic-image-sub'>{subTitle2}</div>
      </div>
    </div>
  );
};

export default ImageCard;
